export const ACCESS_SHARING_FLEET_STEPS = {
  FLEET_SELECTION: 0,
  FLEET_CREATION: 1,
  FLEET_CREATION_NO_FLEETS: 2,
  FLEET_CREATED: 3,
  EQUIPMENT_ADDED: 4,
  ACCESS_SHARING: 5,
  OVERVIEW: 6,
} as const;
